var _path, _path2, _path3, _path4, _path5, _g, _path6, _path7, _path8, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuperTransfer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M371.022 230.81C371.022 300.574 314.84 357.013 245.68 357.013C176.52 357.013 120.338 300.574 120.338 230.81C120.338 161.046 176.52 104.607 245.68 104.607C314.84 104.607 371.022 161.046 371.022 230.81Z",
    fill: "#F0FFF1",
    stroke: "#F0FFF1",
    strokeWidth: 21.5364
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M195.711 161.032H299.937V173.614H260.61C260.61 173.614 273.114 186.7 273.114 195.257H299.822V206.831H274.249C274.249 206.831 269.134 245.886 220.147 243.471L279.933 307.189H256.065L195.711 245.687V232.802C195.711 232.802 225.377 233.606 239.583 225.051C251.063 218.106 249.585 213.878 250.608 209.851C250.95 208.341 249.698 206.933 247.993 206.933H195.711V195.356H249.245C250.38 195.356 251.063 194.349 250.495 193.444C248.22 189.518 242.198 180.76 233.901 179.151C223.102 177.138 195.711 176.634 195.711 176.634V161.032Z",
    fill: "#231942"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2996_3072",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 82,
    y: 12,
    width: 137,
    height: 175
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M82 12H218.11V186.708H82V12Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2996_3072)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2996_3072",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: -33,
    width: 238,
    height: 219
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1953 85.7552L183.698 -32.3965L254.237 67.0036L87.734 185.155L17.1953 85.7552Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2996_3072)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_2996_3072",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: -33,
    width: 238,
    height: 219
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M87.9918 185.525L254.495 67.3729L183.956 -32.0352L17.4531 86.1166L87.9918 185.525Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_2996_3072)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M216.219 13.0244L215.751 14.0878L190.477 71.3107L174.796 106.822L155.783 80.2857C148.847 83.3409 142.11 87.1261 135.682 91.6891C129.849 95.8234 124.556 100.434 119.755 105.394C99.9087 125.891 89.0053 152.689 88.0134 180.114C87.8785 181.876 87.8547 183.384 87.9499 184.614C87.9499 184.876 87.9499 185.138 87.9499 185.399C81.0698 163.275 80.2207 139.969 85.0693 117.844C91.1241 90.2289 106.035 64.4941 128.961 45.2029C129.302 44.8537 129.611 44.5046 129.96 44.1554L111.701 18.6745L216.219 13.0244Z",
    fill: "#F0FFF1"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_2996_3072",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 212,
    y: 279,
    width: 184,
    height: 209
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M341.938 487.759L212.507 445.645L266.563 279.51L395.994 321.624L341.938 487.759Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_2996_3072)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_2996_3072",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 195,
    y: 321,
    width: 232,
    height: 178
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M426.385 437.674L231.496 498.511L195.174 382.163L390.063 321.327L426.385 437.674Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_2996_3072)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask5_2996_3072",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 195,
    y: 320,
    width: 232,
    height: 179
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M389.925 320.892L195.036 381.729L231.355 498.084L426.245 437.248L389.925 320.892Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_2996_3072)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M214.609 445.253L215.383 444.386L257.123 397.792L283.021 368.874L292.891 399.992C300.432 399.232 308.01 397.717 315.534 395.367C322.36 393.24 328.819 390.494 334.919 387.263C360.134 373.912 378.794 351.802 388.223 326.03C388.896 324.396 389.385 322.97 389.675 321.771C389.756 321.522 389.837 321.273 389.918 321.024C389.616 344.191 383.212 366.617 371.756 386.155C357.454 410.542 335.312 430.401 307.542 441.652C307.11 441.878 306.707 442.115 306.267 442.339L315.747 472.219L214.609 445.253Z",
    fill: "#F0FFF1"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuperTransfer);
export default __webpack_public_path__ + "static/media/super_transfer.a5ab44c9e214e480e33420fcba35ff5f.svg";
export { ForwardRef as ReactComponent };